/*eslint-disable*/
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";
import CircularProgress from "@material-ui/core/CircularProgress";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components

import styles from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

const useStyles = makeStyles({
  ...styles,
  buttonAlign: {
    flexDirection: "rowReverse"
  }
});
const useStylesFacebook = makeStyles((theme) => ({
  root: {
    position: "relative"
  },
  bottom: {
    color: theme.palette.grey[theme.palette.type === "light" ? 200 : 700]
  },
  top: {
    color: "#1a90ff",
    animationDuration: "550ms"
    /* position: "absolute", */
    /* left: "50%" */
  },
  circle: {
    strokeLinecap: "round"
  }
}));

export default function SweetAlertPage(props) {
  const classes = useStyles();
  const classesLoading = useStylesFacebook();
  const [alert, setAlert] = useState(null);
  const [inputValue, setInputValue] = useState(null);

  const loadingAlert = (open) => {
    setAlert(
      open ? (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title=""
          onConfirm={() => hideAlert()}
          showConfirm={false}
        >
          <div className={classesLoading.root}>
            <CircularProgress
              variant="determinate"
              className={classesLoading.bottom}
              size={0}
              thickness={4}
              value={100}
            />
            <CircularProgress
              variant="indeterminate"
              disableShrink
              className={classesLoading.top}
              classes={{
                circle: classesLoading.circle
              }}
              size={40}
              thickness={4}
            />
          </div>
        </SweetAlert>
      ) : null
    );
    /* setTimeout(hideAlert, 2000); */
  };

  const successAlert = (message) => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Se ejecutó correctamente!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {message}
      </SweetAlert>
    );
  };

  const errorAlert = (message) => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Algo no salio bien!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {message}
      </SweetAlert>
    );
  };

  const warningAlert = (message) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Atención!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {message}
      </SweetAlert>
    );
  };

  const warningWithConfirmAndCancelMessage = (message) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Estas seguro?"
        onConfirm={() => {
          cancelDetele(), 
          props.stateConfirm(false);
        }}
        onCancel={() => {
          /* successDelete(); */
          props.stateConfirm(true);
        }}
        confirmBtnCssClass={classes.button + " " + classes.danger}
        cancelBtnCssClass={classes.button + " " + classes.success}
        cancelBtnText="Aceptar"
        confirmBtnText="Cancelar"
        showCancel
      >
        {message}
      </SweetAlert>
    );
  };

  const successDelete = (props) => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Eliminado!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Su archivo ha sido eliminado.
      </SweetAlert>
    );
  };

  const cancelDetele = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Cancelado"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Se cancelo correctamente.
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  useEffect(() => {
    if (props.alert.alert == "loading") {
      loadingAlert(props.alert.open);
    } else if (props.alert.alert == "success") {
      successAlert(props.alert.message);
    } else if (props.alert.alert == "error") {
      errorAlert(props.alert.message);
    } else if (props.alert.alert == "warning") {
      warningAlert(props.alert.message);
    } else if (props.alert.alert == "confirm") {
      warningWithConfirmAndCancelMessage(props.alert.message);
    }
  }, [props.alert]);

  return <div>{alert}</div>;
}
